module.exports = __webpack_public_path__ + "static/img/next.41fa88c1.svg";